import $ from 'jquery';

export default function () {
    $('iframe[src*="http:"]')
        .each(function setProtocol(i, el) {
            const $el = $(el);
            const src = $el.attr('src');
            const nSrc = src.replace('http:', 'https:');
            $el.attr('src', nSrc);
        });
}
